module.exports = __webpack_public_path__ + "templates-59e97cd7/template-3-99e73a727f2c9c2b0832b9579570807b.jpg";